import { CrmRolesEnum } from '@sparling/financial-common'

export function getReadableUserType(role: string): string {
  switch (role) {
    case CrmRolesEnum.KycOfficer:
      return 'KYC Officer'
    case CrmRolesEnum.AdminCrm:
      return 'Admin CRM'
    case CrmRolesEnum.MercuryApi:
      return 'Mercury API'
    default:
      return role
  }
}

export enum userPermissionEnum {
  admin = 'admin',
  executor = 'executor',
  accountant = 'accountant',
  viewer = 'viewer',
  // eslint-disable-next-line camelcase
  sole_trader = 'sole_trader',
}
